export default "__VITE_ASSET__c23dddb8__"